import { FileReader, FileWriter } from "@/platform";
import FilePos from "./FilePos.ts";
import ModuleId from "./DataStructModuleId";

/** 剧情 `mapId` 对应 projects.bin 中的模块 mid。 */
export function mapMidForMapId(mapId: number): number {
    return ModuleId.mapInfo + mapId
}

/**
 * 按给定条目数测量 DataMap 序列化字节长度（用于写入前占位）。
 * @param entryCount FilePos 条数（固定模块 + 各 MapInfo）
 */
export function measureDataMapBinByteLength(entryCount: number): number {
    const dm = new DataMap()
    dm.ms = "RESMAP"
    dm.map = Array.from({ length: entryCount }, () => new FilePos())
    const writer = new FileWriter()
    dm.writeBin(writer)
    return writer.length
}

class DataMap{

    public ms:string = "RESMAP"
    public pos: FilePos = new FilePos(0)
    public map:FilePos[] = []

    public startPos(mid:number):number {
        for (let i = 0; i < this.map.length; i++) {
            if (this.map[i] && this.map[i]!.fmid === mid) {
                return this.map[i]!.startPos
            }
        }
        return -1
    }

    public writeBin(writer: FileWriter): void {
        writer.writeString(this.ms)
        writer.writeInt(this.pos.fmid)
        writer.writeInt(this.pos.startPos)
        writer.writeInt(this.pos.dataLength)
        writer.writeInt(this.map.length)
        for (let i = 0; i < this.map.length; i++) {
            const fp = this.map[i] ?? new FilePos()
            writer.writeInt(fp.fmid)
            writer.writeInt(fp.startPos)
            writer.writeInt(fp.dataLength)
        }
    }

    public readBin(reader: FileReader): void {
        this.ms = reader.readString()
        this.pos.fmid = reader.readInt()
        this.pos.startPos = reader.readInt()
        this.pos.dataLength = reader.readInt()
        const mapLength = reader.readInt()
        for (let i = 0; i < mapLength; i++) {
            const fp = new FilePos()
            fp.fmid = reader.readInt()
            fp.startPos = reader.readInt()
            fp.dataLength = reader.readInt()
            this.map.push(fp)
        }
    }
}
export default DataMap